<template>
  <div class="container" style="background-color: #fff;">
    <HeaderComponent :menu-id="3"></HeaderComponent>
    <div class="title-ty" style="position: relative; padding-bottom: 50px;">
      <img class="xiaci-border" style="bottom: -50px; height: 100px;" src="@/assets/image/border-bj-2.png" alt="">
      <div class="title-ty-y">SHUISHI GRADING</div>
      <div class="title-ty-z"><span>机制币送评</span>评级标准</div>
    </div>
    <div style="background-color: #FFFAF4;">
        <ul class="biaozhun-list jizhibi-biaozhun-list">
          <li class="biaozhun-item" style="width: 500px; font-size: 28px; line-height: 58px; margin-right: 30px;">水石评级采用70分制品相评级体系</li>
          <li class="biaozhun-item biaozhun-item-text" style="width: 660px;">按照送评钱币的磨损程度、铸造精度、原光保留、包浆状态、瑕疵缺陷等进
行评级打分。</li>
        </ul>
        <div class="title-s-ty" style="margin: 80px auto 40px; ">分数段位分类</div>
        <ul class="biaozhun-list" style="width: 1200px; margin: 0 auto; padding: 0;">
          <li class="biaozhun-item" style="background-color: #fff;" v-for="item in duanWeiList">
            <div class="biaozhun-item-title" style="font-size: 34px;">{{ item.title }}</div>
            <div class="biaozhun-item-text">{{ item.tag }}</div>
            <div class="biaozhun-item-fen">{{ item.fen }}</div>
            <div class="biaozhun-item-text">{{ item.text }}</div>
          </li>
        </ul>
        
    </div>
    <div style="position: relative; padding: 100px 0;">
      <img class="xiaci-border" style="position: absolute;top: 0; left: 0; transform: rotate(180deg); bottom: -50px; height: 100px;" src="@/assets/image/border-bj-2.png" alt="">
      <div class="title-s-ty">细分分值详细标准</div>
      <div class="xifen-box" v-for="item in fenZhiList" >
        <div class="title-b-ty">{{ item.title }}</div>
        <ul class="xifen-list">
          <li class="xifen-item" v-for="(biaoZhun,index) in item.biaoZhunList">{{ biaoZhun }}</li>
        </ul>
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
      duanWeiList: [
        {
          id: 1,
          title: 'MS',
          tag: '未流通/原光',
          fen:'60—70',
          text: '未流通状态，钱币保留原始光泽，无流通使用磨损，依据钱币底板光度、细节磨损程度进行打分'
        },
        {
          id: 2,
          title: 'AU',
          tag: '近未使用',
          fen:'50/53/55/58',
          text: '接近未流通状态，但钱币存在轻微流通磨损，币面高点少量磨损，底板及币面保留部分原光'
        },
        {
          id: 3,
          title: 'XF',
          tag: '精美流通品',
          fen:'40/45',
          text: '流通品美品，币面的主体文字、图案轮廓完整，高点磨损较为明显，币面底板无大面积腐蚀'
        },
        {
          id: 4,
          title: 'VF',
          tag: '普通流通品',
          fen:'25/30/35',
          text: '长期流通的普通品，整体磨损较大，细节部分磨损缺失，主体图案可辨识'
        },
        {
          id: 5,
          title: '真品无分',
          tag: '真品',
          fen:'无分',
          text: '流通磨损过重、钱体缺陷较多，达不到VF基础标准，币面有贴纸,后加打制戳、墨戳印记等，入盒标注【真品+瑕疵代码】'
        }
      ],
      fenZhiList: [
        {
          id: 1,
          title: '1. MS原光系列',
          biaoZhunList: [
            '（1）MS 70：完全未流通，完美出厂品相，底板无任何划痕、磕碰，全细节饱满，满原光，无氧化瑕疵；',
            '（2）MS 65—MS 69：底板干净，极少的细微痕迹，币面85%以上原光，主体文字图案深峻完整，高点无磨损；',
            '（3）MS 63—MS 64：底板存在少量的细微丝痕，局部存在较轻微弱打，70%以上原光，主体文字图案细节完整；',
            '（4）MS 61—MS 62：币面底板存在多处细小划痕，原光占比50%以上，主体文字图案细节完整；',
            '（5）MS 60：币面底板细小划痕偏多，存在局部轻微磕碰，仍保留原生光泽，无流通磨耗。'
          ]
        },
        {
          id: 2,
          title: '2. AU近未流通系列',
          biaoZhunList: [
            '（1）AU 58：仅存在币面最高点的微量磨损，原光留存＞70%，主体文字图案完整；',
            '（2）AU 55：币面存在局部的轻微流通磨损，币面高点轻微磨损，原光留存＞50%；',
            '（3）AU 53/AU 50：币面轻微流通磨损痕迹，高点轻微磨损，底板部分存原光。'
          ]
        },
        {
          id: 3,
          title: '3. XF/VF流通系列',
          biaoZhunList: [
            '（1）XF 45：图案主体完整，细节大半保留，边道完好，局部磨损；',
            '（2）XF 40：细节小幅缺失，整体品相规整；',
            '（3）VF 35/30/25：大面积磨损，次要花纹缺失，主文字可辨认，无裂补等硬伤。'
          ]
        }
      ]
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
body{
  overflow-x: hidden;
}
</style>